export default __webpack_public_path__ + "static/media/tracker-star.9050adc6.svg";